/**
 * The hero's title-row box that the purchase section portals a copy of its CTAs
 * into. An id rather than a prop because the two live in sibling sections: the
 * CTAs depend on the purchase section's drawer and enquiry state, which would
 * otherwise have to be lifted into the page just to render a second copy.
 */
export const PRODUCT_HERO_CTA_SLOT_ID = 'product-hero-cta-slot';

/**
 * How close to the top of the viewport the hero copy gets before it hands over.
 * Roughly the site header's height, so the actions fade as they slide under it
 * rather than disappearing at the very edge.
 */
export const HERO_CTA_HANDOVER_OFFSET_PX = 140;
